import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Skin } from '@core/interfaces/skin.interface';
import { SessionService } from '@core/services/session.service';
import { NgParticlesService, NgxParticlesModule } from '@tsparticles/angular';
import { Engine, ISourceOptions } from '@tsparticles/engine';
import { loadSlim } from '@tsparticles/slim';
import { CostComponent } from '@core/components/cost/cost.component';
import { BalanceType } from '@core/types/balance.type';
import { SvgIconComponent } from 'angular-svg-icon';
import { ModalService } from '@features/modals/services/modal.service';
import { ClipboardService } from '@core/services/clipboard.service';
import { RouterLink } from '@angular/router';
import { normalizeSkinImage } from '@core/utils/skins.util';

@Component({
  selector: 'app-withdraw-sent-modal',
  imports: [CostComponent, SvgIconComponent, NgxParticlesModule, RouterLink],
  templateUrl: './withdraw-sent-modal.component.html',
  styleUrl: './withdraw-sent-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class WithdrawSentModalComponent {
  readonly offerid = input.required<number>();
  readonly hash = input.required<string>();
  readonly value = input.required<number>();
  readonly skins =
    input.required<Pick<Skin, 'image' | 'name' | 'assetid' | 'price'>[]>();
  readonly balancetype = input<BalanceType>();
  
  skinsWithImages = computed(() => {
    return this.skins().map((s) => ({
      ...s,
      image: normalizeSkinImage(s.image),
    }));
  });

  particlesOptions: ISourceOptions = {
    fullScreen: { enable: false },
    particles: {
      number: {
        value: 20,
      },
      color: {
        value: ['#ffffff'],
      },
      move: {
        direction: 'none',
        enable: true,
        outModes: {
          default: 'out',
        },
        random: true,
        speed: 1.5,
        straight: false,
      },
      opacity: {
        value: { min: 0.17, max: 0.5 },
      },
      size: {
        value: { min: 1, max: 1.2 },
      },
      wobble: {
        enable: false,
      },
    },
  };

  constructor(
    private ngParticlesService: NgParticlesService,
    public sessionService: SessionService,
    private modalService: ModalService,
    public clipboardService: ClipboardService
  ) {}

  ngOnInit() {
    this.ngParticlesService.init(async (engine: Engine) => {
      await loadSlim(engine);
    });
  }

  public closeModal() {
    this.modalService.closeModals(['WithdrawSentModal']);
  }
}
